const API_URL = process.env.REACT_APP_API_URL || '/api';

export function getAdminToken() {
  return localStorage.getItem('dynafi_admin_token') || '';
}

export function setAdminToken(token) {
  if (token) localStorage.setItem('dynafi_admin_token', token);
  else localStorage.removeItem('dynafi_admin_token');
}

async function request(path, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };
  const token = getAdminToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 401 && path !== '/admin/login') {
    setAdminToken('');
    if (window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
  }
  if (!res.ok) {
    const err = new Error(data.message || 'Request failed');
    err.status = res.status;
    throw err;
  }
  return data;
}

export const adminApi = {
  login: (username, password) =>
    request('/admin/login', { method: 'POST', body: { username, password } }),
  dashboard: () => request('/admin/dashboard'),
  me: () => request('/admin/me'),
  changePassword: (body) => request('/admin/me/password', { method: 'PUT', body }),
  settings: (group) => request(`/admin/settings/${group}`),
  updateSettings: (group, body) => request(`/admin/settings/${group}`, { method: 'PUT', body }),
  users: () => request('/admin/users'),
  adjustUserBalance: (id, body) => request(`/admin/users/${id}/balance`, { method: 'POST', body }),
  setUserActive: (id, active) => request(`/admin/users/${id}/status`, { method: 'POST', body: { active } }),
  changeUserWallet: (id, walletAddress) => request(`/admin/users/${id}/address`, { method: 'POST', body: { walletAddress } }),
  purchases: () => request('/admin/purchases'),
  claims: () => request('/admin/claims'),
  stakes: () => request('/admin/stakes'),
  syncStakes: () => request('/admin/stakes/sync', { method: 'POST', body: {} }),
  stakingSlabs: () => request('/admin/staking/slabs'),
  createStakingSlab: (body) => request('/admin/staking/slabs', { method: 'POST', body }),
  updateStakingSlab: (id, body) => request(`/admin/staking/slabs/${id}`, { method: 'PUT', body }),
  deleteStakingSlab: (id) => request(`/admin/staking/slabs/${id}`, { method: 'DELETE' }),
  income: (status) =>
    request(`/admin/income${status ? `?status=${encodeURIComponent(status)}` : ''}`),
  runReturns: (date) =>
    request('/admin/returns/run', { method: 'POST', body: date ? { date } : {} }),
  runReferralPool: (date) =>
    request('/admin/referral-pool/run', { method: 'POST', body: date ? { date } : {} }),
  refreshRanks: () => request('/admin/ranks/refresh', { method: 'POST', body: {} }),
  payRankBonuses: () => request('/admin/ranks/bonus', { method: 'POST', body: {} }),
  admins: () => request('/admin/admins'),
  createAdmin: (body) => request('/admin/admins', { method: 'POST', body }),
  updateAdmin: (id, body) => request(`/admin/admins/${id}`, { method: 'PUT', body }),
  deleteAdmin: (id) => request(`/admin/admins/${id}`, { method: 'DELETE' }),
};
